import ProfileComponent from "../components/auth/ProfileComponent";

export default function Profile() {
  return (
      <ProfileComponent />
  );
}
